import { render, staticRenderFns } from "./CartTableNotificator.vue?vue&type=template&id=4284b292"
import script from "./CartTableNotificator.vue?vue&type=script&lang=js"
export * from "./CartTableNotificator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports